import { render, staticRenderFns } from "./bloodCompatibilities.vue?vue&type=template&id=2dbf1fe6&scoped=true"
import script from "./bloodCompatibilities.vue?vue&type=script&lang=js"
export * from "./bloodCompatibilities.vue?vue&type=script&lang=js"
import style0 from "./bloodCompatibilities.vue?vue&type=style&index=0&id=2dbf1fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf1fe6",
  null
  
)

export default component.exports